
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import { tabConfig } from './config'
export default {
name: 'Layout',
components: {
TabbarItem,
Tabbar
},
data () {
return {
tabConfig
}
},
methods: {

isCurrent (value) {
return this.$route.fullPath.startsWith(`/${value}`)
},
handleTabbarItem (value) {
this.$router.push({ path: `/${value}` })
}
}
}



// WEBPACK FOOTER //
// ./src/views/judge/layout/Layout.vue